interface TrackActionField {
  [key: string]: string | number;
}

interface TrackProduct {
  name: string;
  id: string;
  price: string;
  brand: string;
  category: string;
  variant: string;
  quantity?: number;
  coupon?: string;
  position?: string;
}

interface TrackPayment {
  paymentType: string;
  subpaymentType: string;
  selection?: string | undefined;
  selectionType?: string | undefined;
  amount: number;
  tax: number;
}

export type UserLoginStatus = "userLogin" | "guestLogin" | "notIdentified";
export interface EventMetaData {
  spotOnApi: string;
  source?: string;
  userLoginStatus?: UserLoginStatus;
}

export type RewardType = "storedValue" | "discount" | "reduction";
export type LinkingMethod = "autoApplied" | "manuallyApplied" | "";

export interface LoyaltyDetailsEventMetaData {
  orderId: string;
  paymentType: string;
  subpaymentType: string;
  providerName: string;
  rewardType: RewardType;
  rewardAmount: number;
  linkingMethod: LinkingMethod;
}

export interface TrackEvent {
  event?: TrackEventField;
  userId: string;
  vendorId: string;
  ecommerce: {
    [key: string]:
      | {
          actionField?: TrackActionField;
          products: TrackProduct[] | { barcode: string }[];
          payments?: TrackPayment[] | [];
        }
      | string;
  };
  eventMetaData: EventMetaData;
  eventCallback?: () => void;
}

export interface FailedScanEventMetadata {
  spotOnApi: string;
  source: AddItemSources;
  reason: ScanAndGoRejectReasons;
  barcode: string;
}
export interface GenericEvent {
  event: TrackEventField;
  eventInfo: {
    location: string;
    action: string;
    object: string;
  };
  eventMetadata: EventMetaData | FailedScanEventMetadata | LoyaltyDetailsEventMetaData;
  eventCallback?: () => void;
}

export enum TrackEventField {
  ADD = "addToCart",
  REMOVE = "removeFromCart",
  CLICK = "productClick",
  CHECKOUT = "checkout",
  PURCHASE = "purchase",
  GENERIC_EVENT = "analyticsEvent"
}

export enum TrackEventActions {
  BARCODE_PROCESSED = "barcodeProcessed",
  PURCHASE = "purchase"
}

export enum TrackEventObjects {
  FAILED_TO_ADD_BARCODE = "failedToAddBarcode",
  LOYALTY_PROVIDER_USED = "loyaltyProviderUsed"
}

export enum ScanAndGoRejectReasons {
  INVALID_BARCODE = "invalidBarcode",
  ITEM_WITH_MODIFIERS = "itemWithModifiers",
  ITEM_INACTIVE = "itemInactive",
  ITEM_DAYPARTS_UNAVAILABLE = "itemDayPartsUnavailable",
  ALCOHOL_NOT_ALLOWED = "alcoholNotAllowed",
  ALCOHOL_LIMIT_REACHED = "alcoholLimitReached"
}

export enum AddItemSources {
  MENU = "menu",
  SCAN = "scan",
  SCAN_MANUAL_INPUT = "scanManualInput"
}
